import { servicesUoUAppointmentSchedulingFormFieldLoadClicksSrc16Evid40 } from '@wix/bi-logger-bookings-data/v2';
import { useBi } from '../../../contexts/bi-context';
import { useConfig } from '../../../contexts/config-context';
import { useAppointmentContext } from '../context/appointment-context';
export const getDefaultBiData = (service)=>({
        bookingsServiceId: service?.id,
        formGuid: service?.form?.id,
        serviceProperties: getServiceProperties(service)
    });
export const getServiceProperties = (service)=>JSON.stringify({
        serviceId: service?.id,
        serviceType: service?.type,
        locationIds: service?.locations?.map((location)=>location.id).filter((id)=>id),
        staffMemberIds: service?.staffMemberIds,
        isOfferedAsPricingPlan: false
    });
export const useAppointmentBi = (serviceToUse)=>{
    const { appointmentFieldProps } = useAppointmentContext();
    const { isEditor, isComposer } = useConfig();
    const bi = useBi();
    const service = serviceToUse || appointmentFieldProps?.initialData?.service;
    if (isEditor || isComposer) {
        return;
    }
    return {
        ...bi,
        report: (overrideParams)=>bi?.report(servicesUoUAppointmentSchedulingFormFieldLoadClicksSrc16Evid40({
                ...getDefaultBiData(service),
                ...overrideParams
            }))
    };
};

//# sourceMappingURL=bi.js.map